import moment from 'moment'

import { defaultAnomalyDateRange } from '../core/variables'

export const getAAFTPDetailsAsync = (): ReduxAction => ({
  type: 'GET_AA_FTP_DETAILS_ASYNC',
})

export const getGooglePermissionAsync = (payload: object): ReduxAction => ({
  type: 'GET_GOOGLE_PERMISSION_ASYNC',
  payload,
})

export const requestAnomalyGraphData = (payload: {
  to?: string
  from?: string
  selector?: string
  metricID?: string
}): ReduxAction => {
  if (!payload.to || !payload.from) {
    const now = new Date(Date.now())
    const to = moment(now).subtract(1, 'days').format('YYYYMMDD')
    const from = moment(now)
      .subtract(defaultAnomalyDateRange, 'days')
      .format('YYYYMMDD')

    return {
      type: 'GET_ANOMALY_RANGE_ASYNC',
      payload: {
        ...payload,
        to,
        from,
      },
    }
  }

  return {
    type: 'GET_ANOMALY_RANGE_ASYNC',
    payload,
  }
}

export const getAnomalyCausesAndSolutions = (payload: object): ReduxAction => ({
  type: 'GET_ANOMALY_BREAKDOWN_CAUSES_ASYNC',
  payload,
})

export const getAllSitesAsync = (): ReduxAction => ({
  type: 'GET_ALL_SITES_ASYNC',
})

export const getAllPropertiesAsync = (): ReduxAction => ({
  type: 'GET_ALL_PROPERTIES_ASYNC',
})

export const getAllViewsAsync = (): ReduxAction => ({
  type: 'GET_ALL_VIEWS_ASYNC',
})

export const getAllUsersAsync = (): ReduxAction => ({
  type: 'GET_ALL_USERS_ASYNC',
})

export const getSelectedAccountAsync = (): ReduxAction => ({
  type: 'GET_SELECTED_ACCOUNT_ASYNC',
})

export const getUserListAsync = (): ReduxAction => ({
  type: 'GET_USER_LIST_ASYNC',
})

export const closeAccountsAsync = (): ReduxAction => ({
  type: 'CLOSE_ACCOUNTS_ASYNC',
})

export const logout = (): ReduxAction => ({
  type: 'DELETE_TOKEN',
})

export const getExplainSetup = (): ReduxAction => ({
  type: 'GET_EXPLAIN_SETUP_ASYNC',
})

export const getGaMetrics = (): ReduxAction => ({
  type: 'GET_GA_METRICS_ASYNC',
})

export const getCurrentKeyMetrics = (): ReduxAction => ({
  type: 'GET_CURRENT_KEY_METRICS_ASYNC',
})

export const getAnomalyDateDescription = (payload: {
  metric: string
  date: string
}): ReduxAction => ({
  type: 'GET_ANOMALY_DESCRIPTION_ASYNC',
  payload,
})

export const getAllGaDimensions = (): ReduxAction => ({
  type: 'GET_ALL_GA_DIMENSIONS_ASYNC',
})

export const addMetric = (payload: {
  apiName: string
  displayName: string
  detectionMethod: string
  increaseSentimentPositive: boolean
  sendAlert: boolean
  dataSource: string
}): ReduxAction => ({
  type: 'ADD_METRIC_ASYNC',
  payload,
})

export const updateMetric = (payload: object): ReduxAction => ({
  type: 'UPDATE_METRIC_ASYNC',
  payload,
})

export const saveExplainSetup = (payload: object): ReduxAction => ({
  type: 'SAVE_EXPLAIN_SETUP_ASYNC',
  payload,
})

export const updateAnomalyDescription = (payload: object): ReduxAction => ({
  type: 'UPDATE_ANOMALY_DESCRIPTION_ASYNC',
  payload,
})

export const updateAnomalyDescriptionReducersOnly = (
  payload: object,
): ReduxAction => ({
  type: 'UPDATE_ANOMALY_REDUCERS_ONLY',
  payload,
})

export default {}
